// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___bb751821e434cfb0829","cls2":"FeedbackModal-cls2__c9414bf9c48fa6644955 FeedbackModal-cls1___bb751821e434cfb0829"};